// extracted by mini-css-extract-plugin
export default {"heading":"column-list-nav-module__heading--zqWef","leadingVisual":"column-list-nav-module__leadingVisual--DMhg9"};